import React, { createContext, useState, useEffect } from "react";

const THEME_STORAGE_KEY = "ems-theme";
// Dark mode is temporarily disabled.
const VALID_MODES = ["default", "light"];

export const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [themeMode, setThemeModeState] = useState(() => {
    const stored = localStorage.getItem(THEME_STORAGE_KEY);
    if (stored === "dark") return "default";
    if (VALID_MODES.includes(stored)) return stored;
    if (stored === "erp") return "default"; // migrate old "erp" to "default"
    return "default";
  });

  useEffect(() => {
    const root = document.documentElement;
    root.setAttribute("data-theme", themeMode);
    localStorage.setItem(THEME_STORAGE_KEY, themeMode);
  }, [themeMode]);

  const setThemeMode = (mode) => {
    if (VALID_MODES.includes(mode)) setThemeModeState(mode);
  };

  return (
    <ThemeContext.Provider value={{ themeMode, setThemeMode }}>
      {children}
    </ThemeContext.Provider>
  );
}
